import React from "react";
import { message } from "antd";

import CommentItem from "./commentItem";
import ScrollLoad from "../Scroll/ScrollLoadList";
import { fetchUserProfile, fetchPcComments, fetchPaging } from "@Services/api";
import { fetchCommentAdd, fetchCommentList } from "../../../../services/article";
import { chkLogin } from "../../../../services/user";
import styles from "./index.module.less";
import NewLoginModel from "@Components/Comment/NewLoginModel";

const openNotificationWithIcon = (type, title = "", msg = "") => {
  // notification[type]({
  //   message: title,
  //   description: message,
  // });
  message[type](msg);
};

class Comment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reply_id: "",
      re_mid: "",
      value: "",
      paging: "",
      comment_data: "",
      modalType: "",
      modalObj: {},
      c_data: [],
      interiorCommentData: [],
      modalOpen: false,
      userAvatar: "https://photo.8891.com.tw/2020/09/25/1601023588157267.png",
    };
  }
  ref = React.createRef();
  componentDidMount() {
    this.pcComments(1);
    this.userInfo(1);
    this.handleUpdateCommentList();
  }
  async userInfo() {
    const res = await fetchUserProfile({});
    if (res.status === "12000" && res.data.data.headpic) {
      this.setState({
        userAvatar: res.data.data.headpic,
      });
    }
  }
  async pcComments(cache) {
    const { id } = this.props;

    if (window.page_route === "newCar:shorts/{id}") return;

    let params = {
      id: id,
      page: 1,
      limit: 15,
      cache: cache,
    };
    try {
      const res = await fetchPcComments(params);
      if (res && res.status == "200") {
        let c_data = [];
        c_data.push(res.data);

        this.setState({
          comment_data: res,
          paging: res.paging,
          c_data: c_data,
        });
      }
    } catch (error) {}
  }

  async handleCheckLoginStatus() {
    const res = await chkLogin({});
    if (res && String(res.status) === "200") {
      this.send();
      return;
    }
    openNotificationWithIcon("error", "評論提示", res.error.message);
  }

  // 发布
  send() {
    let content = this.refs["textarea"].value;

    // if (content == "") {
    //   openNotificationWithIcon("error", "評論提示", "評論內容不能為空");
    //   return false;
    // }

    this.setState(
      {
        reply_id: "",
        value: content,
      },
      () => {
        this.sendComment();
      },
    );
  }

  // 回复
  replyComment = (re_id, val, item) => {
    // if (val == "") {
    //   openNotificationWithIcon("error", "評論提示", "評論內容不能為空");
    //   return false;
    // }

    this.setState(
      {
        reply_id: re_id,
        value: val,
        re_mid: item?.user?.mid || "",
      },
      () => {
        this.sendComment();
      },
    );
  };

  handleUpdateCommentList = async () => {
    const { id } = this.props;

    const res = await fetchCommentList({
      limit: 100,
      type: window.page_route === "newCar:shorts/{id}" ? "11" : "3",
      id,
    });

    if (res && res.status === 12000) {
      this.setState({
        interiorCommentData: res.data.list || [],
      });
    }
  };

  sendComment = async () => {
    const { reply_id, value, re_mid } = this.state;
    const { id } = this.props;

    const params = {
      type: window.page_route === "newCar:shorts/{id}" ? "11" : "3",
      id: String(id),
      reId: reply_id ?? "", // 回复记录id
      reMid: re_mid ?? "", // 回复用户id
      content: value,
      // token: localStorage.getItem("accesstoken"),
    };

    const result = await fetchCommentAdd({ ...params });

    if (result.status == 12000) {
      openNotificationWithIcon("success", "評論提示", "評論成功");
      this.handleUpdateCommentList();
      this.refs["textarea"].value = "";
      this.setState({
        value: "",
      });
    } else {
      openNotificationWithIcon("error", "評論提示", result?.data?.message ?? result?.error?.message);
    }
  };

  async onEndReached() {
    const { paging, c_data } = this.state;

    if (paging == "") {
      return false;
    }

    try {
      const res = await fetchPaging(paging);

      let n_data = [];
      n_data.push(res.data);

      this.setState({
        comment_data: res,
        c_data: [...c_data, ...n_data],
        paging: res.paging,
      });
    } catch (error) {}
  }
  render() {
    const { id } = this.props;
    const { comment_data, c_data, paging, userAvatar, interiorCommentData, modalOpen } = this.state;

    return (
      <div>
        <section className={styles["Comment"]} id='Comment'>
          <div className={styles["title"]}>
            <h2>留言</h2>
            <span>{`${(Number(comment_data.comment_num) || 0) + (interiorCommentData.length || 0)}條`}</span>
          </div>
          <div className={styles["message"]}>
            <img src={userAvatar} className={styles["avatar"]} />
            <div className={styles["content"]}>
              <textarea className={styles["textarea"]} ref='textarea' placeholder='快來發表你的看法吧' />
              <div className={styles["btn-list"]}>
                <button
                  className={styles["send-btn"]}
                  onClick={() => {
                    let content = this.refs["textarea"].value;
                    if (content == "") {
                      openNotificationWithIcon("info", "評論提示", "評論內容不能為空");
                      return;
                    }
                    this.setState({
                      modalOpen: true,
                      modalType: "sendBtn",
                    });
                  }}
                >
                  發佈
                </button>
              </div>
            </div>
          </div>
        </section>

        {interiorCommentData.length > 0 && (
          <section className={styles["commnet-list"]}>
            <p className='text-16 text-[#333333] my-30 font-bold'>8891留言</p>
            <CommentItem
              data={interiorCommentData}
              dot={true}
              replyComment={(re_id, val, item) => {
                if (val == "") {
                  openNotificationWithIcon("info", "評論提示", "評論內容不能為空");
                  return false;
                }
                this.setState({
                  modalOpen: true,
                  modalType: "replyBtn",
                  modalObj: { re_id, val, item },
                });
              }}
            />
          </section>
        )}

        {!!(comment_data?.data || []).length && (
          <section className={styles["commnet-list"]}>
            <p className='text-16 text-[#333333] my-30 font-bold'>Youtube留言</p>
            <ScrollLoad
              onEndReached={() => this.onEndReached()}
              onEndReachedThreshold={1500}
              data={c_data}
              paging={paging}
              loadRef={this.ref}
            >
              {c_data.map((v, i) => (
                <CommentItem type={"ytb"} key={i} data={v} dot={true} />
              ))}
            </ScrollLoad>
          </section>
        )}

        <NewLoginModel
          title='發佈評論，與更多用戶交流互動！'
          desc='立即登入，用戶回覆後將同步您'
          visible={modalOpen}
          onClose={() => {
            openNotificationWithIcon("info", "", "您已取消登錄，將以遊客身份發佈評論");
          }}
          setVisible={(status) => {
            const { re_id, val, item } = this.state.modalObj;
            this.state.modalType === "sendBtn" ? this.send() : this.replyComment(re_id, val, item);
            this.setState({
              modalOpen: status,
            });
          }}
        />
      </div>
    );
  }
}

export default Comment;
